module.exports = __webpack_public_path__ + "img/PTS_BDO.b6ce1e55.gif";